// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__3Zl5u"};